(() => {
	if(typeof IntersectionObserver === 'undefined' || typeof fetch === 'undefined') return;

	const instances = document.querySelectorAll('.eriks-reviews[data-infinite]');

	if(!instances.length) return;

	const observer = new IntersectionObserver((entries, observer) => {
		for(const entry of entries) {
			if(!entry.isIntersecting) return;

			observer.unobserve(entry.target);

			const reviews = entry.target.parentElement;
			const instance = reviews.parentElement;
			const offset = reviews.querySelectorAll('.review').length;
			const limit = instance.getAttribute('data-limit') || 5;

			fetch(`/eriks-ajax/reviews/latest?offset=${offset}&limit=${limit}`).then(res => res.json()).then(elements => {
				for(let i = 0, l = elements.length; i < l; i++) {
					const element = reviews.appendChild(htmlToElement(elements[i]));

					if(i === l - 1) {
						observer.observe(element);
					}
				}
			});
		}
	});

	for(const reviews of instances) {
		const last = reviews.querySelector('.review:last-child');
		if(last) {
			observer.observe(last);
		}
	}
})();

(() => {
	const instances = document.querySelectorAll('.eriks-reviews.horizontal');

	if(!instances.length) return;

	for(const instance of instances) {
		scrollable(instance);
	}

	function scrollable(instance) {
		let startPos = null;
		let scroll = null;
		let scrollLeft = null;
		let lastTick = 0;
		let scrollSpeed = 0;
		let startedEasing = false;
		const easingDuration = 400;

		instance.addEventListener('mousedown', start);
		instance.addEventListener('mouseup', stop);
		instance.addEventListener('mouseleave', stop);
		instance.addEventListener('mousemove', move);

		function start(e) {
			startPos = e.x;
			scrollLeft = scroll = instance.scrollLeft;
			instance.classList.add('dragging');
			loop();
		}

		function move(e) {
			if(startPos === null) return;

			scrollLeft = scroll + (startPos - e.x);
		}

		function stop(e) {
			if(startPos === null) return;

			startPos = null
			scroll = null;
			startedEasing = true;
			instance.classList.remove('dragging');
		}

		function loop() {
			if(startPos === null && !startedEasing) {
				return;
			}

			const now = Date.now();

			if(startedEasing) {
				if(startedEasing === true) {
					startedEasing = now;
				}

				const easingProgressMs = (now - startedEasing);
				const easingProgress = (startedEasing === now ? 0 : easingProgressMs / easingDuration);

				scrollLeft += (scrollSpeed * 12 * (1 - easingProgress));

				if(easingProgress >= 1) {
					startedEasing = false;
					return;
				}
			}
			else {
				if(lastTick) {
					scrollSpeed = (scrollLeft - instance.scrollLeft) / (now - lastTick)
				}
			}

			instance.scrollLeft = scrollLeft;
			lastTick = now;

			requestAnimationFrame(loop);
		}
	}
})();

function htmlToElement(html) {
	var template = document.createElement('template');
	html = html.trim();
	template.innerHTML = html;

	return template.content.firstChild;
}

function ease(t) {
	return -t * (t - 2.0)
}